
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from '@uifabric/merge-styles';

const classNames = mergeStyleSets({
    root: {
        width: '100%'
    }
})

const OperationItemList = ({
    onRenderOperationItem,
    operationItems
}) => {

    return (
        <Stack className={classNames.root}>
            {(operationItems.length > 0)
                ? operationItems.map(item => {
                    return onRenderOperationItem(item);
                })
                : (
                    <div>Neexistuje žádná položka ceníku pro tuto operaci</div>
                )
            }
        </Stack>
    );
}

export default OperationItemList;
